import React, { useState } from 'react';
import { Container, TextField, Button, Typography, Box } from '@mui/material';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const Signup = () => {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSignup = async (e) => {
    e.preventDefault();
    setError(''); // Clear any previous errors

    try {
      const response = await axios.post('https://api.example.com/signup', { username, email, password });
      console.log(response.data); // Xử lý sau khi đăng ký thành công
      navigate('/login'); // Điều hướng đến trang đăng nhập sau khi đăng ký thành công
    } catch (err) {
      setError('Đăng ký thất bại. Vui lòng thử lại.');
    }
  };

  return (
    <Container maxWidth="xs">
      <Typography variant="h4" component="h1" gutterBottom textAlign="center">
        Đăng ký
      </Typography>
      <form onSubmit={handleSignup}>
        <TextField
          label="Tên người dùng"
          fullWidth
          margin="normal"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
        />
        <TextField
          label="Email"
          type="email"
          fullWidth
          margin="normal"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <TextField
          label="Mật khẩu"
          type="password"
          fullWidth
          margin="normal"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        {error && (
          <Typography color="error" variant="body2">
            {error}
          </Typography>
        )}
        <Box mt={2}>
          <Button type="submit" fullWidth variant="contained" color="primary">
            Đăng ký
          </Button>
        </Box>
      </form>
      <Box mt={2}>
        <Typography variant="body2" align="center">
          Đã có tài khoản? <Button color="primary" onClick={() => navigate('/login')}>Đăng nhập</Button>
        </Typography>
      </Box>
    </Container>
  );
};

export default Signup;
